export const internalDomainList = [
  '@logmein.com', // former logmein
  '@goto.com', // current goto
  '@jive.com', // former jive
  '@jedix.com', // domain used for internal mail
  '@guthrie.com', // domain used for training
]

export enum Product {
  WEB = 'gtc-web',
}
export const isInternal = (email?: string) =>
  email ? !!internalDomainList.find(domain => email.toLowerCase().endsWith(domain)) : false
